<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <div class="form-group row">
            <div class="col-xl-3 col-md-3">
              <h5> Date identificare</h5>
            </div>
          </div>
        </div>
        <div class="card-body tab2-card">
          <form [formGroup]="accountForm" class="needs-validation" novalidate>
            <div class="form-group row" *ngIf="false">
              <div class="col-xl-3 col-md-3">
                <label>CUI<span>*</span></label>
                <input class="form-control" type="text" formControlName="cui" disabled>
              </div>
              <div class="col-xl-3 col-md-3 button-div">
                <button type="button" class="btn btn-primary" disabled>Interogare RECOM</button>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Data infiintare<span>*</span></label>
                <input class="form-control" type="date" formControlName="creationDate" (change)="checkDate($event)"
                  onkeydown="return false" />
                <div *ngIf="accountForm.controls['creationDate'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Data infiintare obligatorie
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Denumire<span>*</span></label>
                <input class="form-control" type="text" formControlName="name" />
                <div *ngIf="accountForm.controls['name'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Nume companie obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Forma juridica<span>*</span></label>
                <select class="form-control digits" formControlName="legalForm">
                  <option>Societate pe acţiuni (SA)</option>
                  <option>Societate cu răspundere limitată (SRL)</option>
                  <option>Persoană fizică autorizată (PFA)</option>
                  <option>Regie autonoma (RA)</option>
                  <option>Institutie publica</option>
                  <option>Societate în nume colectiv</option>
                  <option>Societate în comandită simplă</option>
                  <option>Societate în comandită pe acţiuni</option>
                  <option>Întreprindere individuală (ÎI)</option>
                  <option>Întreprindere familială (ÎF)</option>
                  <option>Altele</option>
                </select>
                <div *ngIf="accountForm.controls['legalForm'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Forma juridica obligatorie
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>CUI<span>*</span></label>
                <input class="form-control" type="text" formControlName="cui" />
                <div *ngIf="accountForm.controls['cui'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  CUI sau invalid
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Nr. inregistrare la ONRC<span>*</span></label>
                <input class="form-control" type="text" formControlName="onrcRegistrationNumber" />
                <div
                  *ngIf="accountForm.controls['onrcRegistrationNumber'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numar inregistrare ONRC obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Telefon</label>
                <input class="form-control" type="text" formControlName="phoneNumber" />
                <div *ngIf="accountForm.controls['phoneNumber'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numarul de telefon contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Mobil</label>
                <input class="form-control" type="text" formControlName="mobileNumber" />
                <div *ngIf="accountForm.controls['mobileNumber'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numarul de telefon mobil contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Fax</label>
                <input class="form-control" type="text" formControlName="fax" />
                <div *ngIf="accountForm.controls['fax'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numarul de fax contine caractere invalide.
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Email</label>
                <input class="form-control" type="text" formControlName="email" />
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Tip client<span>*</span></label>
                <input class="form-control" formControlName="clientType" disabled>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Functia<span>*</span></label>
                <input class="form-control" formControlName="position" required>
                <div *ngIf="accountForm.controls['position'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Functia obligatorie
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4> Adresa sediu social</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div *ngIf="accountForm.controls['county'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Judetul sediului social este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="city">
                  <option *ngFor="let city of cities" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div *ngIf="accountForm.controls['city'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Orasul sediului social este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetName" />
                <div *ngIf="accountForm.controls['streetName'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numele strazii sediului social este obligatorie
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="streetNumber" />
                <div *ngIf="accountForm.controls['streetNumber'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numarul strazii sediului social este obligatorie
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="block" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="floor" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="apartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="postalCode" />
                <div *ngIf="accountForm.controls['postalCode'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Codul postal al sediului social este obligatoriu.
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <span class="bold"> Adresa de corespondență</span>
              </div>
              <div class="col-xl-3 col-md-3">
                <label class="d-block" for="chk-ani">
                  <input class="checkbox_animated" id="chk-ani" type="checkbox" (click)="toggleSameAddress()"
                    formControlName="sameAddress" [checked]="isSameAddress">
                  Aceeasi cu adresa sediului social
                </label>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Judet<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCounty"
                  (change)="onChangeCountyCorrespondence()">
                  <option *ngFor="let county of counties" [value]="county.id">
                    {{ county.name }} </option>
                </select>
                <div
                  *ngIf="accountForm.controls['correspondenceCounty'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-sm-3 mb-0">
                <label>Localitate<span>*</span></label>
                <select class="form-control digits" formControlName="correspondenceCity">
                  <option *ngFor="let city of citiesCorrespondence" [value]="city.id">
                    {{ city.name }} </option>
                </select>
                <div
                  *ngIf="accountForm.controls['correspondenceCity'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Judetul adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Strada<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetName" />
                <div
                  *ngIf="accountForm.controls['correspondenceStreetName'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numele strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Numar<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondenceStreetNumber" />
                <div
                  *ngIf="accountForm.controls['correspondenceStreetNumber'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Numarul strazii adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <label>Bloc</label>
                <input class="form-control" type="text" formControlName="correspondenceBlock" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Etaj</label>
                <input class="form-control" type="text" formControlName="correspondenceFloor" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Apartament</label>
                <input class="form-control" type="text" formControlName="correspondenceApartment" />
              </div>
              <div class="col-xl-3 col-md-3">
                <label>Cod postal<span>*</span></label>
                <input class="form-control" type="text" formControlName="correspondencePostalCode" />
                <div
                  *ngIf="accountForm.controls['correspondencePostalCode'].errors &&  (accountForm.dirty || accountForm.touched)"
                  class="text text-danger">
                  Codul postal al adresei de corespondenta este obligatoriu
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <h4 class="d-block" for="ee-client">
                <input id="ee-client" type="checkbox" [disabled]="!this.editable"
                  [checked]="this.accountForm.value.isElectricalEnergyClient" formControlName="isElectricalEnergyClient"
                  (change)="setIsElectricalEnergyClient()">
                Client energie electrica
              </h4>
            </div>
            <div *ngIf="this.accountForm.value.isElectricalEnergyClient">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Sunteți prosumator?</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="isProsumer" [disabled]="!this.editable"
                      [checked]="this.accountForm.value.isProsumer" (click)="setIsProsumer(true)">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="isProsumer" [disabled]="!this.editable"
                      [checked]="!this.accountForm.value.isProsumer" (click)="setIsProsumer(false)">
                    NU
                  </label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Sunteți autofurnizor?</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="isSelfSupplier" [disabled]="!this.editable"
                      [checked]="this.accountForm.value.isSelfSupplier" (click)="setIsSelfSupplier(true)">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="isSelfSupplier" [disabled]="!this.editable"
                      [checked]="!this.accountForm.value.isSelfSupplier" (click)="setIsSelfSupplier(false)">
                    NU
                  </label>
                </div>
              </div>
              <div class="form-group row mt-5">
                <div class="col-xl-3 col-md-3">
                  <h4>Date agregare</h4>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Faceți parte dintr-o agregare?</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="aggregation"
                      [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                      [checked]="this.accountForm.value.isAggregate" (click)="setIsAggregate(true)">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="aggregation"
                      [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                      [checked]="!this.accountForm.value.isAggregate" (click)="setIsAggregate(false)">
                    NU
                  </label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Agregatorul este: </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="aggregatorIs"
                      (click)="onAggregatorType('Persoana fizica')" [attr.disabled]="(!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                      !this.accountForm.controls.isAggregate.value)? true : null"
                      [checked]="this.accountForm.value.aggregatorClientType === 'PERSOANA_FIZICA' ">
                    Persoana fizica
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="aggregatorIs"
                      (click)="onAggregatorType('Persoana juridica')" [attr.disabled]="(!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                      !this.accountForm.controls.isAggregate.value)? true : null"
                      [checked]="this.accountForm.value.aggregatorClientType === 'PERSOANA_JURIDICA' ">
                    Persoana juridica
                  </label>
                </div>
              </div>
              <ng-container *ngIf="this.accountForm.value.isAggregate">
                <div class="form-group row" *ngIf="this.accountForm.value.aggregatorClientType === 'PERSOANA_FIZICA'">
                  <div class="col-xl-3 col-md-3">
                    <label>Nume<span>*</span></label>
                    <input class="form-control" type="text" formControlName="aggregationPersonName"
                      [attr.disabled]="!editable? true : null">
                    <div *ngIf="accountForm.controls['aggregationPersonName'].errors"
                      class="text text-danger">
                      Numele este obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Prenume<span>*</span></label>
                    <input class="form-control" type="text" formControlName="aggregationPersonSurname"
                      [attr.disabled]="!editable? true : null">
                    <div *ngIf="accountForm.controls['aggregationPersonSurname'].errors"
                      class="text text-danger">
                      Prenumele este obligatoriu
                    </div>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>CNP<span>*</span></label>
                    <input class="form-control" type="text" formControlName="aggregationPersonCnp"
                      [attr.disabled]="!editable? true : null">
                    <div *ngIf="accountForm.controls['aggregationPersonCnp'].errors"
                      class="text text-danger">
                      CNP-ul este obligatoriu
                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="form-group row" *ngIf="this.accountForm.value.aggregatorClientType === 'PERSOANA_JURIDICA'">
                <div class="col-xl-3 col-md-3">
                  <label>Denumire<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationName"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationName'].errors"
                    class="text text-danger">
                    Denumirea obligatorie
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Forma juridica<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationJuridicalForm"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationJuridicalForm'].errors"
                    class="text text-danger">
                    Forma juridica obligatorie
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>CUI<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationCui"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationCui'].errors"
                    class="text text-danger">
                    CUI obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Nr. inregistrare la ONRC<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationOnrcRegistrationNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationOnrcRegistrationNumber'].errors"
                    class="text text-danger">
                    Nr. inregistrare la ONRC obligatoriu
                  </div>
                </div>
              </div>
              <div class="form-group row" *ngIf="this.accountForm.value.aggregatorClientType === 'PERSOANA_JURIDICA'">
                <div class="col-xl-3 col-md-3">
                  <label>Telefon<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationPhoneNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationPhoneNumber'].errors"
                    class="text text-danger">
                    Telefon obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Mobil<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationMobilePhoneNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationMobilePhoneNumber'].errors"
                    class="text text-danger">
                    Mobil obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Fax<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationFax"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationFax'].errors"
                    class="text text-danger">
                    Fax obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Email<span>*</span></label>
                  <input class="form-control" type="text" formControlName="aggregationEmail"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['aggregationEmail'].errors"
                    class="text text-danger">
                    Email obligatoriu
                  </div>
                </div>
              </div>
              <div class="form-group row mt-5">
                <div class="col-xl-3 col-md-3">
                  <h4>Date parte responsabila cu echilibrarea</h4>
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Ati delegat responsabilitatea echilibrarii catre un PRE?</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="balancingProcessDelegate"
                      [disabled]="!this.accountForm.value.isElectricalEnergyClient || !editable"
                      [checked]="this.accountForm.value.balancingProcessHasDelegatedPRE"
                      (click)="setHasDelegatedPRE(true)" [attr.disabled]="!editable? true : null">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="balancingProcessDelegate"
                      [disabled]="!this.accountForm.value.isElectricalEnergyClient || !editable"
                      [checked]="!this.accountForm.value.balancingProcessHasDelegatedPRE"
                      (click)="setHasDelegatedPRE(false)">
                    NU
                  </label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Aveti delegat alt PRE?</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="balancingProcessOtherPRE"
                      [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                      [checked]="this.accountForm.value.balancingProcessHasOtherPRE" (click)="setHasOtherPRE(true)">
                    DA
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="balancingProcessOtherPRE"
                      [disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient"
                      [checked]="!this.accountForm.value.balancingProcessHasOtherPRE" (click)="setHasOtherPRE(false)">
                    NU
                  </label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>PRE-ul este:</label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="preType"
                      (change)="onBalancingProcessPreType('Persoana fizica')"
                      [attr.disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                      !(this.accountForm.value.balancingProcessHasOtherPRE || this.accountForm.value.balancingProcessHasDelegatedPRE)? true : null"
                      [checked]="this.accountForm.value.balancingProcessPreType === 'PERSOANA_FIZICA'">
                    Persoana fizica
                  </label>
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="preType"
                      (change)="onBalancingProcessPreType('Persoana juridica')"
                      [attr.disabled]="!this.editable || !this.accountForm.value.isElectricalEnergyClient ||
                      !(this.accountForm.value.balancingProcessHasOtherPRE || this.accountForm.value.balancingProcessHasDelegatedPRE)? true : null"
                      [checked]="this.accountForm.value.balancingProcessPreType === 'PERSOANA_JURIDICA'">
                    Persoana juridica
                  </label>
                </div>
              </div>

              <div class="form-group row" *ngIf="this.accountForm.value.balancingProcessPreType === 'PERSOANA_FIZICA'">
                <div class="col-xl-3 col-md-3">
                  <label>Nume<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessPersonName"
                    [attr.disabled]="!editable? true : null">
                  <div *ngIf="accountForm.controls['balancingProcessPersonName'].errors"
                    class="text text-danger">
                    Nume obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Prenume<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessPersonSurname"
                    [attr.disabled]="!editable? true : null">
                  <div *ngIf="accountForm.controls['balancingProcessPersonSurname'].errors"
                    class="text text-danger">
                    Prenume obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>CNP<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessPersonCnp"
                    [attr.disabled]="!editable? true : null">
                  <div *ngIf="accountForm.controls['balancingProcessPersonCnp'].errors"
                    class="text text-danger">
                    CNP obligatoriu
                  </div>
                </div>
              </div>
              <div class="form-group row"
                *ngIf="this.accountForm.value.balancingProcessPreType === 'PERSOANA_JURIDICA'">
                <div class="col-xl-3 col-md-3">
                  <label>Denumire<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessName"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessName'].errors"
                    class="text text-danger">
                    Denumire obligatorie
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Forma juridica<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessJuridicalForm"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessJuridicalForm'].errors"
                    class="text text-danger">
                    Forma juridica obligatorie
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>CUI<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessCui"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessCui'].errors"
                    class="text text-danger">
                    CUI obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Nr. inregistrare la ONRC<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessRegistrationNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessRegistrationNumber'].errors"
                    class="text text-danger">
                    Nr. inregistrare la ONRC obligatoriu
                  </div>
                </div>
              </div>
              <div class="form-group row"
                *ngIf="this.accountForm.value.balancingProcessPreType === 'PERSOANA_JURIDICA'">
                <div class="col-xl-3 col-md-3">
                  <label>Telefon<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessPhoneNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessPhoneNumber'].errors"
                    class="text text-danger">
                    Telefon obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Mobil<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessMobilePhoneNumber"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessMobilePhoneNumber'].errors"
                    class="text text-danger">
                    Mobil obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Fax<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessFax"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessFax'].errors"
                    class="text text-danger">
                    Fax obligatoriu
                  </div>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Email<span>*</span></label>
                  <input class="form-control" type="text" formControlName="balancingProcessEmail"
                    [attr.disabled]="!editable? true : null" />
                  <div *ngIf="accountForm.controls['balancingProcessEmail'].errors"
                    class="text text-danger">
                    Email obligatoriu
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-3 col-md-3">
                <h4>Documente justificative</h4>
              </div>
            </div>
            <br>
            <div class="form-group row">
              <div class="col-xl-8 col-md-8">
                <span class="font-weight-bold">Fisier</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Dimensiune</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span class="font-weight-bold">Optiuni</span>
              </div>
            </div>
            <div class="form-group row" *ngFor="let document of documents; let ind = index">
              <div class="col-xl-8 col-md-8">
                <span>{{document.fileName}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <span *ngIf="document.fileByteSize">{{document.fileByteSize | fileSize}}</span>
              </div>
              <div class="col-xl-2 col-md-2">
                <a *ngIf="document.file || document.fileUrl" class="link pointer"
                  (click)="documentService.downloadDocument(document)">Descarca</a>
              </div>
            </div>
            <br>
            <br>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Container-fluid Ends-->
